import { type ApiResource } from './portal-types';

export const DEFAULT_ENDPOINT_ID = 'requests-lane-booking';

export const API_RESOURCES: readonly ApiResource[] = [
  {
    name: 'Users',
    icon: 'users',
    description:
      'Groups and booking users in your enterprise — the ids you need to place a booking.',
    docId: 'users',
    firstEndpointId: 'users-get-booking-users',
  },
  {
    name: 'Lanes',
    icon: 'route',
    description: 'Your contracted routes — locations, vehicle and trailer type, and agreed rates.',
    docId: 'lanes',
    firstEndpointId: 'lanes-get-lanes',
  },
  {
    name: 'Requests',
    icon: 'paper-plane',
    description: 'Place a booking on a lane. A valid request immediately creates an order.',
    docId: 'requests',
    firstEndpointId: 'requests-lane-booking',
  },
  {
    name: 'Orders',
    icon: 'box-check',
    description: 'Confirmed shipments — status, stops, carrier details, and PODs.',
    docId: 'orders',
    firstEndpointId: 'orders-detail',
  },
  {
    name: 'Webhooks',
    icon: 'bell',
    description: 'Status updates pushed to your endpoint, with APIs to list and retrigger events.',
    docId: 'webhooks',
    firstEndpointId: 'webhooks-paginated',
  },
];
